import CommonFunctions from "./CommonFunctions";
export default class ValidationHelper {
    static validatePictureUploadResult(e) {
        const files = e.files;
        let valid = true;
        $.each(files, (index, element) => {
            if (element.extension.toLowerCase() !== ".png"
                && element.extension.toLowerCase() !== ".jpg"
                && element.extension.toLowerCase() !== ".jpeg"
                && element.extension.toLowerCase() !== ".bmp"
                && element.extension.toLowerCase() !== ".gif") {
                CommonFunctions.showError(TextResources.Views_Fehler, TextResources.Error_OnlyPictureAllowed);
                e.preventDefault();
                valid = false;
            }
            if (element.size / 1024 / 1024 > 1) {
                CommonFunctions.showError(TextResources.Views_Fehler, TextResources.Error_Max1Mb);
                e.preventDefault();
                valid = false;
            }
        });
        return valid;
    }
}
